import * as types from './actionTypes';
import { NotificationDescription, NotificationType } from './util';

export interface NotificationState {
  notificationDescription: NotificationDescription;
}

const initialState: NotificationState = {
    notificationDescription: {
    visible: false,
    notificationType: NotificationType.Info,
  },
};

export default function reduce(
  state: NotificationState = initialState,
  action: types.NotificationAction
): NotificationState {
  switch (action.type) {
    case types.TOGGLE_NOTIFICATION: {
      return {
        ...state,
        notificationDescription: {
          visible: action.visible,
          notificationType: action.notificationType,
          message: action.message,
          description: action.description,
          duration: action.duration,
          placement: action.placement
        },
      };
    }
    default:
      return state;
  }
}
